// filterInvoiceStatements.js — the tab + filter-pill predicate, shared by the tile
// grid and the table view so both show exactly the same set of statements.
export function filterInvoiceStatements(statements, activeSection, appliedFilters) {
   return (statements || []).filter((file) => {
      const hasInvStatId = file?.inv_stat_id != null && file?.inv_stat_id !== "";
      const hasStatement = hasInvStatId || (file?.statement_state && file.statement_state !== "SETUP");

      if (activeSection === "setup") return !hasStatement;
      if (["unreconciled", "reconciled", "location", "month"].includes(activeSection)) {
         if (!hasStatement) return false;
      }

      if (appliedFilters.suppliers.length > 0 && !appliedFilters.suppliers.includes(file.sm_name)) {
         return false;
      }

      if (["recent", "unreconciled", "reconciled", "location"].includes(activeSection)) {
         const { from, to } = appliedFilters.dateRange;
         if (from && to && file.sup_state_frmt_statement_date) {
            const fileDate = file.sup_state_frmt_statement_date.substring(0, 10);
            if (fileDate < from || fileDate > to) return false;
         }
      }

      if (["recent", "unreconciled", "reconciled"].includes(activeSection)) {
         if (appliedFilters.locations.length > 0 && !appliedFilters.locations.includes(file.sup_state_type)) {
            return false;
         }
      }

      if (activeSection === "month" && appliedFilters.years.length > 0) {
         const fileYear = file.sup_state_frmt_statement_date
            ? file.sup_state_frmt_statement_date.substring(0, 4)
            : null;
         if (!fileYear || !appliedFilters.years.includes(fileYear)) return false;
      }

      return true;
   });
}
